function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,1137.000000) scale(0.100000,-0.100000)",
  fill: "#c72e49",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3085 11353 c-185 -39 -343 -129 -490 -277 -118 -119 -182 -220 -231 -363 -82 -243 -67 -490 46 -718 65 -133 142 -232 361 -465 186 -198 250 -264 734 -765 434 -450 643 -674 710 -764 120 -159 215 -379 250 -575 19 -114 20 -337 0 -450 -74 -426 -347 -793 -733 -986 -44 -22 -85 -40 -91 -40 -8 0 -11 286 -11 1075 0 591 -3 1075 -7 1075 -12 0 -237 -123 -373 -203 -517 -307 -946 -642 -1381 -1076 -222 -223 -345 -359 -516 -574 -641 -801 -1143 -1846 -1333 -2776 -11 -57 -19 -106 -16 -108 3 -3 434 213 958 480 1350 686 1964 997 1972 997 3 0 6 -937 6 -2082 l0 -2082 337 -338 c186 -186 341 -338 345 -338 5 0 8 1171 8 2603 l0 2603 209 108 c115 59 255 134 310 167 828 489 1186 1481 866 2398 -72 207 -215 456 -358 621 -35 41 -390 415 -788 830 -399 415 -753 786 -788 823 -121 131 -147 250 -83 379 78 160 246 227 409 166 48 -18 79 -41 182 -142 68 -67 225 -229 349 -361 417 -443 1549 -1626 1606 -1677 43 -39 53 -43 73 -30 32 21 15 51 -735 1282 -605 993 -705 1144 -853 1286 -163 156 -350 257 -551 299 -89 19 -301 18 -393 -2z m-161 -5750 c-12 -24 -44 -46 -138 -96 -267 -143 -1659 -857 -1670 -857 -4 0 28 69 72 153 414 793 968 1471 1662 2032 l85 69 3 -635 c3 -574 1 -637 -14 -666z"
}));

const SvgMinio = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "563.000000pt",
  height: "1137.000000pt",
  viewBox: "0 0 563.000000 1137.000000",
  preserveAspectRatio: "xMidYMid meet",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMinio, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/minio.c56d907c.svg";
export { ForwardRef as ReactComponent };